import React from 'react';
import { BsFormControl, BsModalForm, BsFormSelect } from '../../collection/bootstrap/BootstrapComponents';
import { apiForm, apiGet } from '../../utils/api';
import ListadoFechas from '../project/ListadoFechas';

export default function ConvenioModal(props) {
    const isNew = props.idConvenio < 1;

    const updateData = async () => await apiGet("convenios/get/" + props.idConvenio);

    const checkData = formData => {
        let errors = {};
        // Año
        const ano = formData.get("ano");
        if (!ano || !Number.isInteger(+ano) || +ano < 2022) {
            errors["ano"] = "Año no válido";
        }
        // Nombre
        const name = formData.get("name");
        if (!name) {
            errors["name"] = "Campo obligatorio";
        }
        // Num días vacaciones
        const numDiasVacaciones = formData.get("numDiasVacaciones");
        if (!numDiasVacaciones || !Number.isInteger(+numDiasVacaciones) || +numDiasVacaciones < 0 || +numDiasVacaciones > 365) {
            errors["numDiasVacaciones"] = "Número no válido";
        }
        // Jornada anual
        const jornadaAnual = formData.get("jornadaAnual");
        if (!jornadaAnual || !Number.isInteger(+jornadaAnual) || +jornadaAnual < 0 || +jornadaAnual > 2100) {
            errors["jornadaAnual"] = "Número no válido";
        }
        return errors;
    }

    const saveData = async data => {
        const action = isNew ? "new" : "edit";
        const result = await apiForm("convenios/" + action, data);
        if (result) {
            props.onHide();
        }
    }

    return (
        <BsModalForm
            isNew={isNew}
            onUpdate={updateData}
            onCheck={checkData}
            onSave={saveData}
            modalTitle={isNew ? "Nuevo convenio" : "Editar convenio"}
            show={props.show}
            onHide={props.onHide}
            saveOnEnter>
            <ConvenioForm />
        </BsModalForm>
    );
}

function ConvenioForm(props) {
    const data = props.data;
    const errors = props.errors;
    const nameOptions = [
        { value: 'Siderometal Pontevedra', label: 'Siderometal Pontevedra' },
        { value: 'Comercio Metal Pontevedra', label: 'Comercio Metal Pontevedra' },
        { value: 'Siderometal Coruña', label: 'Siderometal Coruña' },
        { value: 'Comercio Vario Coruña', label: 'Comercio Vario Coruña' },
        { value: 'Siderometal Lugo', label: 'Siderometal Lugo' },
    ];
    return <>
        <BsFormControl
            /* Año */
            label="Año" name="ano"
            value={data.ano} error={errors.ano}
            type="number" />
        <BsFormSelect
            /* Nombre */
            label="Nombre" name="name"
            value={data.name} error={errors.name}
            options={nameOptions}
            className="mt-3" />
        <BsFormControl
            /* Días de vacaciones */
            label="Días de vacaciones" name="numDiasVacaciones"
            value={data.numDiasVacaciones} error={errors.numDiasVacaciones}
            className="mt-3" type="number" />
        <BsFormControl
            /* Jornada anual */
            label="Jornada anual" name="jornadaAnual"
            value={data.jornadaAnual} error={errors.jornadaAnual}
            className="mt-3" type="number" />
        <ListadoFechas
            /* Días de convenio */
            label="Días de convenio" name="dias[]"
            fechas={data.dias}
            className="mt-3" />
    </>;
}
